module.exports = __webpack_public_path__ + "img/s5-2.0a428989.jpg";